import { useEffect, useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";

// Pixally ships Jan 1 — count down to the next one so this never goes stale.
function daysUntilLaunch() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (today.getMonth() === 0 && today.getDate() === 1) return 0;
  const target = new Date(today.getFullYear() + 1, 0, 1);
  return Math.round((target - today) / 86400000);
}

// Kept to the card's margins so they read as light, not as typos in the copy.
const SPARKS = [
  { top: "12%", left: "90%", delay: "0s" },
  { top: "86%", left: "7%", delay: "1.1s" },
  { top: "52%", left: "94%", delay: "2.3s" },
  { top: "30%", left: "4%", delay: "3.1s" },
];

export default function PixallyAd() {
  const [days, setDays] = useState(daysUntilLaunch);

  useEffect(() => {
    const tick = setInterval(() => setDays(daysUntilLaunch()), 3600000);
    return () => clearInterval(tick);
  }, []);

  return (
    <a
      data-testid="pixally-ad"
      href="https://pixally.com"
      target="_blank"
      rel="noopener noreferrer"
      className="pixally-ad group mt-auto"
      title="Pixally — join the waitlist"
    >
      <div className="pixally-inner px-3.5 py-3">
        {SPARKS.map((s, i) => (
          <span key={i} className="pixally-spark" style={{ top: s.top, left: s.left, animationDelay: s.delay }} />
        ))}

        <div className="relative flex items-center gap-1.5">
          <span className="pixally-dot" />
          <span className="font-mono text-[8px] uppercase tracking-[0.2em] text-[#5ba89d]">
            {days === 0 ? "Launching today" : "Launches Jan 1"}
          </span>
          <Sparkles className="ml-auto h-3 w-3 text-[#5ba89d]/40 transition-colors group-hover:text-[#5ba89d]" />
        </div>

        <h3
          className="pixally-wordmark relative mt-2 text-[20px] font-bold leading-none"
          style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
        >
          Pixally
        </h3>

        <p className="relative mt-1.5 text-[11px] leading-snug text-[#a1a1aa]">
          The all-in-one CRM for wedding videographers.
        </p>

        <div className="relative mt-3 flex items-center justify-between">
          <span className="flex items-center gap-1 text-[10px] font-semibold text-[#8fd8cc] transition-colors group-hover:text-white">
            Join the waitlist
            <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
          </span>
          {days > 0 && (
            <span className="font-mono text-[9px] tracking-wider text-[#52525b]">{days} days</span>
          )}
        </div>
      </div>
    </a>
  );
}
